export const RESEND_CODE_COUNTER = 30;

export const TEST_ID = {
  resendButton: 'resendButton',
};
